import { useField } from 'formik';

import { Text } from '../../../cdl/Text/Text';
import { formatPrice } from '../../helpers/formatPrice.helper';
import { FormikMoneyInput } from '../../MoneyInput/FormikMoneyInput';

interface PriceDisplayProps {
    name: string;
    editable?: boolean;
}

export const PriceDisplay = ({ name, editable = true }: PriceDisplayProps) => {
    const [field] = useField(name);
    const item = field.value;

    if (!item.price && (!editable || item.deleted)) {
        return (
            <Text variant="small" textAlign="right">
                -
            </Text>
        );
    }

    if (!editable) {
        return (
            <Text variant="small" textAlign="right">
                {formatPrice(item.price)}
            </Text>
        );
    }

    return (
        <FormikMoneyInput
            name={`${name}.price.value`}
            decimals={4}
            disabled={item.deleted}
            allowNegativeValue={false}
        />
    );
};
